import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from '../components/home/home.component';
import {ChartsComponent} from '../components/charts/charts.component';
import {LoginComponent} from "../login/login.component";

const routes: Routes = [
    {path: 'login', component: LoginComponent},
    {path: 'home', component: HomeComponent},
    {path: 'classifiche', component: ChartsComponent},
    // Here add new pages component

    {path: '**', component: LoginComponent} // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class RoutesModule { }
